import { get } from "lodash-es";

export const regionsParser = (response, dispatch) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return [];
        }
        if (response.results)
            response.results = response.results.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    name: get(row, "name", ""),
                    code: get(row, "code", ""),
                    is_active: get(row, "is_active", false),
                    created_at: get(row, "created_at", ""),
                };
            });

        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const productsParser = (response, dispatch) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return [];
        }
        if (response.results)
            response.results = response.results.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    name: get(row, "name", ""),
                    image_url: get(row, "image_url", ""),
                    price: get(row, "price", 0),
                    mrp: get(row, "mrp", null),
                    video_url: get(row, "video_url", ""),
                    images: get(row, "images", []),
                    description: get(row, "description", ""),
                    is_active: get(row, "is_active", false),
                    created_at: get(row, "created_at", ""),
                };
            });

        return response;
    } catch (error) {
        throw new Error(error);
    }
};
